import { useEffect } from 'react';
import { buildPageTitle } from '@/common/utils/app.utils';
import { DEFAULT_PAGE_TITLE } from '@/core/utils/app.constants';

function usePageTitle(title: string) {
  const pageTitle = title ? buildPageTitle(title) : DEFAULT_PAGE_TITLE;

  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle;
    }
  }, [pageTitle]);
}

export { usePageTitle };
